export default __webpack_public_path__ + "static/media/proclamation1.abfde083.jpg";